/**
 * WordPress dependencies
 */
import { store as CORE } from '@safe-wordpress/core-data';
import { _x } from '@safe-wordpress/i18n';

/**
 * External dependencies
 */
import type { PremiumActionTypeDefinition } from '@nelio/forms/types';

const action: PremiumActionTypeDefinition = {
	isPremium: true as const,
	isUnique: false,
	type: 'user-registration',
	label: _x( 'User registration', 'text', 'nelio-forms' ),
	icon: 'admin-users',
	canCurrentUserUse: ( select ) =>
		!! select( CORE ).canUser( 'create', 'users', '' ),
};

export default action;
